import { BUBBLETAP_TEL, supportEmail } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function YouthProtectionPolicyJa() {
  return (
    <Styled.MainWrapper>
      <h3 style={{ marginBottom: '40px' }}>株式会社BubbleTap 青少年保護方針</h3>
      株式会社BubbleTap（以下「当社」といいます）は、青少年の安全なインターネット利用を支援するため、情報通信網の利用促進及び情報保護等に関する法律で定められた青少年保護方針を実施しています。
      <p>第1条 青少年の保護に関する目標および基本原則</p>
      青少年が精神的・身体的に有害な環境から保護され、健全に成長できるよう努め、安全にインターネットを利用できるサービスを提供するため、青少年保護方針を明示しています。{' '}
      <p>第2条 青少年有害情報に対する青少年保護措置及び管理措置</p>
      青少年が制限措置なしに有害情報にさらされないよう、青少年有害メディア物に対して年齢認証措置を整備・適用しており、成人認証措置が整備されたサービスについては利用範囲を制限するなどの管理を実施しています。また、当社は違法な内容や青少年有害なコンテンツを継続的にモニタリングし、管理しています。{' '}
      <p>第3条 青少年有害情報による被害相談および苦情処理</p>
      有害情報による被害相談および苦情処理のため、専門の人員を配置し、被害が拡大しないよう努めています。以下の青少年保護責任者の所属、氏名、連絡先をご確認いただき、被害相談や苦情処理を依頼することも可能です。自力で処理が困難な場合は、関連機関をご案内しています。{' '}
      <p>第4条 青少年を有害情報から保護するための教育</p>
      当社は、青少年保護担当者および各サービス担当者に対し、青少年保護に関する各種関連法令および制裁基準、有害情報発見時の対応方法、違反事項の処理に関する報告手続きなどについて教育を実施しています。{' '}
      <p>第5条 青少年保護責任者および担当者の指定</p>
      以下のとおり、青少年保護責任者および青少年保護担当者を指定し、青少年有害情報の遮断管理、青少年を有害情報から保護する政策の策定など、健全なインターネット環境を整備するための各種活動を展開します。
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>区分</th>
              <th>名称</th>
              <th>所属</th>
              <th>役職</th>
              <th>電話番号</th>
              <th>お問い合わせ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                青少年保護
                <br />
                責任者
              </td>
              <td>パク・ジョンボム</td>
              <td>BubbleTapチーム</td>
              <td>CEO</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
              <td>{supportEmail('ja')}</td>
            </tr>
            <tr>
              <td>
                青少年保護
                <br />
                責任者
              </td>
              <td>パク・ヨンウン</td>
              <td>BubbleTapチーム</td>
              <td>室長</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
              <td>{supportEmail('ja')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Styled.MainWrapper>
  );
}
